<template>
  <div id="land-from">
    <div
      style="
        margin-top: 10px;
        margin-left: 30px;
        color: #057ee5;
        cursor: pointer;
      "
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"></i>
      <span> 返回</span>
    </div>
    <div v-if="!isSuccess">
      <div class="land-from-span">提交需求</div>
      <div class="land-from-box">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="80px"
          class="info-form"
        >
          <el-form-item label="企业名称" prop="enterpriseName">
            <el-input v-model="form.enterpriseName"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="person">
            <el-input v-model="form.person"></el-input>
          </el-form-item>

          <el-form-item label="所需面积" prop="areaValue">
            <el-input v-model="form.areaValue" type="number">
              <template slot="append">亩</template>
            </el-input>
          </el-form-item>
          <el-form-item label="行政区划" prop="countyArr">
            <el-cascader
              v-model="form.countyArr"
              :options="xzqhList"
              :props="{ checkStrictly: true }"
              @change="changeCounty"
              clearable
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="意向园区" prop="parkCode">
            <el-select
              v-model="form.parkCode"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in parkList"
                :key="index"
                :label="item.parkName"
                :value="item.parkCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="土地用途" prop="landPurpose">
            <el-cascader
              v-model="form.landPurpose"
              :options="tdytList"
              :props="{
                checkStrictly: true,
                value: 'code',
                label: 'name',
                children: 'child',
              }"
              clearable
              style="width: 100%"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="用途描述" prop="purposeRemark">
            <el-input
              type="textarea"
              v-model="form.purposeRemark"
              :autosize="{ minRows: 4, maxRows: 6 }"
            ></el-input>
          </el-form-item>

          <div class="form-btn">
            <el-button class="btn-submit btn-default" @click="submitBefore"
              >提交</el-button
            >
            <el-button class="btn-default" @click="resetForm('ruleForm')"
              >重置</el-button
            >
          </div>
        </el-form>
      </div>
    </div>

    <div class="tig" v-else>
      <div class="iconfont icon-yiwancheng icon"></div>
      <div>您的用地需求已提交，内容已推送至{{ countyName }}管理员。</div>
      <div class="tig-button" @click="$router.go(-1)">返回上一级</div>
    </div>
    <el-dialog width="370px" title="验证" :visible.sync="dialogTableVisible">
      <div>
        <el-form :model="form" label-width="100px" class="info-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系方式" prop="phone" :rules="phone">
                <el-input v-model="form.phone"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- <el-button @click="dialogTableVisible = true">验证</el-button> -->
              <el-form-item label="短信验证码" prop="code" :rules="code">
                <el-input v-model="form.code">
                  <el-button
                    slot="append"
                    :disabled="phoneDisabled"
                    @click="phoneClick"
                    :class="phoneDisabled ? '' : 'blue'"
                  >
                    <span v-if="phoneShow">发送验证码</span>
                    <span v-else>重新发送({{ timeCount }}s)</span>
                  </el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog
      width="370px"
      title="请正确填写图中验证码"
      :visible.sync="dialogTableVisible1"
      append-to-body
      custom-class="code-dialog"
    >
      <el-form :model="form" label-width="80px" class="info-form">
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item prop="random" label="验证码" :rules="random">
              <el-input
                v-model="form.random"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <img :src="codeUrl" class="login-code" @click="refreshCode" />
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      width="370px"
      title="将下列拼图挪动到正确的位置"
      :visible.sync="dialogTableVisible3"
    >
      <slider-verify
        ref="sliderVerify"
        :random="random1"
        :phone="form.phone"
        @success="onSuccess"
        @fail="onFail"
        @again="onAgain"
      ></slider-verify>
    </el-dialog>
  </div>
</template>
<script>
import {
  getXzqhList,
  dictionaries,
  getCode,
  getTypeList,
  requireCode,
  captchaCode,
} from "@/api/common/index";
import {
  addRequirement,
  getXzqhParkList,
  getPhoneCode,
} from "@/api/setting/investment";
import { randomLenNum } from "@/utils/util";
import sliderVerify from "./components/sliderVerify.vue";
export default {
  name: "land-from",
  components: { sliderVerify },
  data() {
    return {
      position: [100.264162, 25.615269],
      mapView: undefined,
      configList: mapConfig.configList,
      dialogTableVisible1: false,
      dialogTableVisible3: false,
      form: {
        countyArr: [],
        area: "",
        parkCode: "",
        random: "",
        randomStr: "",
      },
      codeUrl: "",
      dialogTableVisible: false,
      phone: [
        { required: true, message: "请填写联系电话", trigger: "blur" },
        {
          pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
          message: "请输入合法手机号/电话号",
          trigger: "blur",
        },
      ],
      random: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      rules: {
        person: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        // phone: [
        //   { required: true, message: "请填写联系电话", trigger: "blur" },
        //   {
        //     pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
        //     message: "请输入合法手机号/电话号",
        //     trigger: "blur",
        //   },
        // ],

        enterpriseName: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        areaValue: [
          { required: true, message: "请填写所需面积", trigger: "blur" },
        ],
        // area: [{ required: false, message: "请绘画范围", trigger: "blur" }],
        // landPurpose: [
        //   { required: true, message: "请选择土地用途", trigger: "blur" },
        // ],
        countyArr: [
          { required: true, message: "请选择行政区", trigger: "blur" },
        ],
        purposeRemark: [
          { required: true, message: "请填写用地需求说明", trigger: "blur" },
        ],
      },
      //行政区划数组
      xzqhList: [],
      tdytList: [],
      loading: false,
      parkList: [],
      isSuccess: false,
      countyName: "",
      phoneDisabled: false,
      phoneShow: true,
      timeCount: "",
      isGrey: false, //按钮样式
      timer: null, //设置计时器,
      randomStr: "",
      random1: null, //刷新值
    };
  },
  mounted() {
    this.getXzqh();
    //this.getField("TDYT", "tdytList");
    this.gettdlx();
    this.refreshCode();
    // this.getPark();
  },
  methods: {
    /* 滑动验证成功*/
    onSuccess(captcha) {
      this.dialogTableVisible3 = false;
      let TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.isGrey = true;
        this.phoneShow = false;
        this.phoneDisabled = true;
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
          } else {
            this.phoneDisabled = false;
            this.isGrey = false;
            this.phoneShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      // Object.assign(this.loginForm, captcha);

      // this.login();
    },
    /* 滑动验证失败*/
    onFail(msg) {
      this.$message.error(msg || "验证失败，请控制拼图对齐缺口");
    },
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试");
    },
    refreshCode() {
      this.form.random = "";
      this.codeUrl = systemConfig.serverUrl + "/code"; //验证码接口
      this.form.randomStr = randomLenNum(4, true);
      this.codeUrl = `${this.codeUrl}?randomStr=${this.form.randomStr}`;
    },
    getYzm() {
      if (!this.form.random) {
        this.$message.error("请输入验证码");
        return false;
      }
    },
    submit1() {
      if (!this.form.random) {
        this.$message.error("请输入验证码");
        return false;
      }
      this.execute();
    },
    phoneClick() {
      if (!this.form.phone) {
        this.$message.error("请输入联系号码");
        return false;
      }
      let case1 = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(this.form.phone);
      if (!case1) {
        this.$message.error("请输入正确的联系号码");
        return;
      }
      this.dialogTableVisible3 = true;
      this.random1 = Math.floor(Math.random() * (9999 - 1000 + 1) + 1000);
    },
    execute() {
      if (!this.timer) {
        // this.timeCount = TIME_COUNT;
        // this.isGrey = true;
        // this.phoneShow = false;
        // this.phoneDisabled = true;
        this.getCode(this.form.phone, this.form.random, this.form.randomStr);
      }
    },
    getCode(val, code, randomStr) {
      requireCode({
        phone: val,
        code: code,
        randomStr: randomStr,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.dialogTableVisible1 = false;
          let TIME_COUNT = 60;
          if (!this.timer) {
            this.timeCount = TIME_COUNT;
            this.isGrey = true;
            this.phoneShow = false;
            this.phoneDisabled = true;
            this.timer = setInterval(() => {
              if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
                this.timeCount--;
              } else {
                this.phoneDisabled = false;
                this.isGrey = false;
                this.phoneShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$message.error(res.data.msg);
          this.refreshCode();
        }
      });

      // getPhoneCode({ phone: val }).then((res) => {
      //   if (res.data.success) {
      //     this.$message.success(res.data.msg);
      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // });
    },
    getPark(code) {
      getXzqhParkList(code).then((res) => {
        if (res.data.success) {
          this.parkList = res.data.data;
        }
      });
    },
    gettdlx() {
      getTypeList().then((res) => {
        if (res.data.success) {
          this.tdytList = res.data.data;
        }
      });
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    //获取行政区划
    getXzqh() {
      getXzqhList({ key: "53" }).then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.county = [];
      this.form.area = "";
    },
    getCountyName() {
      getCode({ value: this.form.county }).then((res) => {
        if (res.data.success) {
          this.countyName = res.data.data;
        }
      });
    },
    submitBefore() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.dialogTableVisible = true;
        }
      });
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let len = this.form.countyArr.length;
          this.form.county = this.form.countyArr[len - 1];

          this.getCountyName();

          if (this.form.landPurpose && this.form.landPurpose.length) {
            this.form.landPurpose = this.form.landPurpose.join(",");
          }

          addRequirement(this.form).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.msg);
              // this.$router.go("-1");
              //this.closeNeed();
              this.isSuccess = true;
              this.dialogTableVisible = false;
              this.loading = false;
            } else {
              this.$message.error(res.data.msg);
              this.loading = false;
              dialogTableVisible = false;
            }
          });
        }
      });
    },
    //选择行政区划定位到当前位置
    changeCounty(val) {
      if (val.length) {
        let len = val.length;
        let index = null;
        if (len == 1) {
          index = 2;
        } else if (len == 2) {
          index = 1;
        } else if (len == 3) {
          index = 0;
        }
        this.form.parkCode = "";
        this.getPark(val[val.length - 1]);
        // this.mapView.queryArcGISRestByAttribute(
        //   layerConfig.SSQ_Layer,
        //   index,
        //   `XZQDM like '${val[val.length - 1]}%'`,
        //   (res) => {
        //     if (res.features.length && res.features[0].geometry) {
        //       let zb = res.features[0].geometry.rings;
        //       let extent = this.mapView.getPolygonExtent(zb);
        //       this.mapView.zoomToExtent(
        //         extent[0],
        //         extent[1],
        //         extent[2],
        //         extent[3]
        //       ); //居中地图范围
        //     }
        //   }
        // );
      }
    },
    //绘画
    draw() {
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        this.mapView = this.$refs.tzMap.tzApi;
        this.mapView.drawGeometry(
          "Polygon",
          (coords) => {
            this.form.area = JSON.stringify(coords);
            let coordinates = this.mapView.getCenterOfPolygon(coords);
            //绘画范围后选择对应行政区划
            if (coordinates.length) {
              this.mapView.queryArcGISRestByGeometry(
                layerConfig.SSQ_Layer,
                0,
                coords,
                "esriGeometryPoint",
                (res) => {
                  if (res.features.length) {
                    let attributes = res.features[0].attributes;
                    if (attributes["XZQDM"]) {
                      getCode({ value: attributes["XZQDM"] }).then((res) => {
                        if (res.data.success && !res.data.msg) {
                          this.$message.error("没有查询到对应行政区划");
                          this.form.county = [];
                        } else {
                          let len = attributes["XZQDM"].length;
                          let county = [];
                          if (len == 6) {
                            let str1 = attributes["XZQDM"].substring(0, 2); //省
                            let str2 = attributes["XZQDM"].substring(0, 4); //市
                            county.push(str1, str2, attributes["XZQDM"]);
                          } else if (len == 4) {
                            let str1 = attributes["XZQDM"].substring(0, 2); //省
                            county.push(str1, attributes["XZQDM"]);
                          } else {
                            county.push(attributes["XZQDM"]);
                          }
                          this.form.county = county;
                        }
                      });
                    }
                  }
                }
              );
            }
          },
          true
        );
      });
    },
    closeNeed() {
      this.$emit("close-need");
    },
    onSubmit() {
      if (this.form.area) {
        this.$message.success("成功选取绘画范围！");
        this.dialogTableVisible = false;
      } else {
        this.$message.warning("请选取绘画范围！");
      }
    },
  },
};
</script>
<style scoped>
#land-from {
  /* min-height: calc(100% - 70px); */
  min-height: calc(100% - 346px);
  width: 60%;
  margin: auto;
  background: #fff;
  display: table;
}
.land-from-box {
  margin: 30px auto;
  width: 500px;
  text-align: center;
  padding: 35px 35px;
  box-shadow: 0px 0px 25px -6px #ababab;
}
.land-from-span {
  margin-top: 40px;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: black;
}

.btn-submit {
  background: #157cf3;
  color: #fff !important;
}
.btn-default {
  color: #157cf3;
  border: 1px solid #157cf3;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.tig {
  margin: 150px auto;
  color: rgb(9, 106, 170);
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
}
.tig-button {
  width: 120px;
  padding: 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  background: rgb(9, 106, 170);
  color: #fff;
  margin: 10px auto;
}
.icon {
  font-size: 70px;
  color: #3d79af;
  margin: 0 auto 15px;
}
.grey {
  background-color: #edeef1;
  border-color: #edeef1;
  color: #666;
  width: 30%;
}
.blue {
  background-color: #0f87ff !important;
  border-color: #0f87ff !important;
  color: #fff !important;
}
.login-code {
  width: 100%;
  height: 26px;
  border: 1px #e8e8e8 solid;
  cursor: pointer;
  z-index: 1;
}
</style>
<style >
.code-dialog {
  margin-top: 30vh !important;
}
</style>
